<template>
  <div v-if="data" :class="$style.root">
    <div
      v-if="!data.richText && !data?.images?.data?.length"
      :class="$style.title"
    >
      {{ participant?.title }}
    </div>
    <shared-participants-link-to-modal-component
      :id="id"
      :disabled="!data.richText && !data?.images?.data?.length"
      :class="$style.title"
      v-else
    >
      {{ participant?.title }}
    </shared-participants-link-to-modal-component>

    <div
      v-if="participant?.subtitle"
      :class="$style.subtitle"
    >
      {{ participant?.subtitle }}
    </div>

    <div
      v-if="participant?.annotation"
      :class="$style.annotation"
    >
      {{ participant?.annotation }}
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
  id: number | null
}>()

const participant = formatParticipantHeadingObject(props.data)
</script>

<style module>
.root {
  text-indent: -1ch;
  padding-left: 1ch;
}

.title,
.subtitle {
  composes: font-size-small from global;
}

.annotation {
  composes: font-size-small from global;
}
</style>
